export default function () {
	if (location.href.split("#")[1] == "/") {
		location.href = "/#/Inicio";
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/verify.js